var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"tabs nav nav-tabs my-profile__btn-wrap w-100 bg-transparent"},_vm._l((_vm.tabs),function(tab,index){return _c('button',{key:index,class:[
      'nav-link btn-sm',
      { 'text-black active': tab.active, 'text-white': tab.color } ],on:{"click":function($event){return _vm.setActive(tab, index)}}},[_vm._v(" "+_vm._s(tab.caption)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }